import { useQuery } from '@tanstack/react-query';
import { getPersonnelByOrg } from '../contactsRequest'

export const getJournalistsByOutletOptions = (outletId) => {
  return {
    queryKey: ['journalists', { outletId }],
    queryFn: () => getPersonnelByOrg(outletId),
  };
};

export const useJournalistsByOutlet = (outletId) => {
  return useQuery(getJournalistsByOutletOptions(outletId));
};
